import axios from "axios"
import library from "../../../utils/Library"

export const getAllSubscriptions = async (data) => {
  const TOKEN = sessionStorage.getItem("token")
  const URL =
    library.getBaseAPIUrl("legal_communications") +
    "/getAllSubscriptionsCommunicationVE"

  return await axios({
    url: URL,
    method: "POST",
    headers: {
      Authorization: `Bearer ${TOKEN}`,
    },
    data
    // params: { perPage:  }
  })
}
